<template>
  <div class="userInfo">
    <el-descriptions class=" wars"   border :column="1"  label-class-name="my-label_userInfo" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="机构名称">{{datas.organisationName}}</el-descriptions-item>
      <el-descriptions-item   :span="1" label="电话">{{datas.organisationPhone}}</el-descriptions-item>
      <el-descriptions-item   :span="1" label="联系人">{{datas.organisationContact}}</el-descriptions-item>
      <el-descriptions-item   :span="1" label="邮箱">{{datas.organisationMail}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="企业信用代码">{{datas.account}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="地址">{{datas.organisationAddress}}</el-descriptions-item>
    </el-descriptions>
  </div>

</template>

<script>

export default {

  data() {
    return {
      datas: {},
      // 表单校验
      rules: {
        nickName: [
          { required: true, message: "用户昵称不能为空", trigger: "blur" }
        ],
        email: [
          { required: true, message: "邮箱地址不能为空", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        phonenumber: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {

  },

  created() {
    this.datas = JSON.parse(sessionStorage.getItem('userInfo'))  || ''
  },
  methods: {

    close() {

      this.$router.go(-1)

    }
  }
};
</script>
<style lang="less">
.userInfo {
  width: 98%;
  margin-left: 1%;
  .titles{
    color: rgb(27, 61, 109);
    font-size:1.25rem ;
    font-weight: 700;
    margin-top: 1rem;
  }

  .btnBox{
    text-align: right;

    button{
      margin-top: 0.5rem;
    }

  }
}

</style>



// WEBPACK FOOTER //
// src/landmark-user/views/userInfo/userInfo.vue